import React from 'react'
import { useSelector } from 'react-redux'
import { Dropdown } from 'primereact/dropdown'
import { selectAllAssets } from 'providers/AssetLoader/store/selectors'

/**
 * Contact Type filter template that gets options from assets
 * @param {object} options - Filter options from PrimeReact column
 */
const ContactTypeFilterTemplate = ({ options }) => {
    const assets = useSelector(selectAllAssets)
    const contactTypes = assets?.contactTypes || []
    
    const dropdownOptions = [
        { label: 'Empty', value: '__EMPTY__' },
        ...contactTypes.map(ct => ({
            label: ct.description,
            value: ct.description
        }))
    ]

    return (
        <Dropdown
            value={options.value}
            options={dropdownOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(e) => options.filterCallback(e.value, options.index)}
            placeholder="Select Contact Type"
            className="p-column-filter"
            showClear
        />
    )
}

export default ContactTypeFilterTemplate
